import { CursoDTO } from "../curso/cursoDTO";
import { TurnoDTO } from "../curso/turnoDTO";
import { UnidadeDTO } from "../curso/unidadeDTO";

export class LeadDTO {
  id!:number;
  idSessao!: string;
  status!: string;
  nome!: string;
  email!: string;
  telefone!: string;
  curso!: CursoDTO;
  unidade?: UnidadeDTO; // opcional, pois só será preenchida em alguns casos
  turno?: TurnoDTO;
  dataCadastro!: Date;
  origem: 'Botão "Inscreva-se" menu principal' | 'Botão "Inscreva-se" Página de cursos' | 'Formulário “Informe-se”' | 'Formulário Página Personalizada' | 'Inserção Manual';
  nomeOrigem: string;
  urlOrigem: string;
  ultimaPaginaVisitada: string;

  getStatus():string{

    if(this.status==='CANDIDATO'){
      return 'Candidato';
    }

    if (this.status === 'NAO_INSCRITO') {
      return 'Não Inscrito';
    }

    if (this.status === 'MATRICULADO') {
      return 'Matriculado';
    }

  }
}
